import { BCMSCurrency, BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { CardOnFileMerchant, Transaction, TransactionDispute } from "model";
import DisputeDissatisfiedConfirmPage from "components/pages/DisputeTransactionPages/DisputeDissatisfiedConfirmPage";
import DisputeDissatisfiedConfirmView, { getDefaultData, getDefaultUI } from "components/pages/DisputeTransactionPage/components/DisputeDissatisfiedConfirmView";

export default function CaptureDisputeSubmitted(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ Transaction, TransactionDispute ], controller);
        const { branding } = useModel();
    const options = branding.options ?? {};
    
    let transactionID = "98"; // A credit card transaction id.
    if(options.include_credit_chw23 === "false") {
        transactionID = "5"; // A debit card transaction id.
    }
    const data = BCMSStateManagerCRUD.init(getDefaultData(transactionID))
    .update(["dispute", "whatAreYouTryingToDispute"], "merchandise")
    .update(["dispute", "whatDidYouPurchase"], "Nike Air Force 1 `07 White / Action Green Women's Shoes")
    .update(["dispute", "wasTheMerchandiseDeliveredElectronically"], "no")
    .update(["dispute", "whyAreYouDissatisfiedWithTheMerchandise"], "The sneakers were dirty and looked like they had been worn already.")
    .update(["dispute", "didYouReturnTheMerchandise"], "yes")
    .update(["dispute", "howDidYouReturnTheMerchandise"], "fedex")
    .update(["dispute", "whenWasTheMerchandiseReturned"], BCMSDate.init([30,1,2022]))
    .update(["dispute", "howMuchOfTheTransactionAmountAreYouDisputing"], "full")
    .update(["dispute", "didYouAttemptToContactTheMerchantToResolveTheIssue"], "yes")
    .update(["dispute", "whenDidYouAttemptToResolveThisissue"], BCMSDate.init([3,5,2022]))
    .update(["dispute", "whatWasTheMerchantsResponseAndMethodOfCommunication"], "I sent them multiple emails.")
    .update(["dispute", "isThereAnyAdditionalInformationYouWouldLikeToProvide"], "no")
    .submit();

    return (
        <DisputeDissatisfiedConfirmPage data={ data }/>
    );
}